import TeamDetailMember from '@/screens/TeamDetailMember';

export default function PrivateTabsOrganizationEventTeamTeamIdIndexRoute() {
  return (
    <TeamDetailMember memberPathname="/organization/event/team/member/[personId]" />
  );
}
